import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { SidemeduFacadeService } from "../side-menu/sidemedu-facade.service";
import { NewSidemeduFacadeService } from "./newsidemedu-facade.service";
import { EstadoCuentaFacadeService } from "src/app/modules/clientes-afiliados/estado-cuenta/estado-cuenta-facade.service";
import { AfiliadosService } from "src/app/modules/afiliados/afiliados.service";

declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}


@Component({
  selector: "app-nuevo-side",
  templateUrl: "./nuevo-side.component.html",
  styleUrls: ["./nuevo-side.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class NuevoSideComponent implements OnInit {
  public usuario:any;
 public getfoto: any = '';
 
  constructor(public srvAfiliado: AfiliadosService,public estadoCuentaFacade:EstadoCuentaFacadeService, public sideMenuFacade:NewSidemeduFacadeService) {
    this.sideMenuFacade.consumirMenus();
    this.usuario = JSON.parse(localStorage.getItem("data_go504"));

  }
  cargandoImagen:boolean
  ngOnInit(): void {
    this.cargandoImagen=true;
    this.estadoCuentaFacade.mostrarDatosGenerales('');

    this.estadoCuentaFacade.responseDatosGenerales$.subscribe((result)=>{
      if(result.table0?.length > 0){
        if(result.table0[0].keyImg){
          this.srvAfiliado.mostrasVoucher(result.table0[0].keyImg,data=>{
            this.getfoto=data.data[0].table0[0].url;
            this.cargandoImagen=false;

          });
        }
        
      }
    });
    
  }
}
